import { createAsyncThunk, createSelector, createSlice } from "@reduxjs/toolkit";
import makeAjaxRequest from "helpers/makeAjaxRequest";
import { rootUrl } from "../actions/constants";

const initialState = {
  selectedRow: {},
  associatedInstitutions: [],
  fwaBrowserFilters: null
};

const selectTable = state => state.fwa;

export const selectedFWARowSelector = createSelector(
  [selectTable],
  fwa => fwa.selectedRow || {}
);

export const fwaBrowserFiltersSelector = createSelector(
  [selectTable],
  fwa => fwa.fwaBrowserFilters || {}
);

export const associatedInstitutionsSelector = createSelector(
  [selectTable],
  fwa => fwa.associatedInstitutions || []
);

export const fetchAssociatedInstitution = createAsyncThunk(
  "fwa/associatedInstitution",
  async (params, { rejectWithValue }) => {
    const { assuranceNumber, ctepId } = params;
    if (!assuranceNumber) {
      return [];
    }
    try {
      const response = await makeAjaxRequest.postWithAuth(`${rootUrl}/admin/fwa/browse`, {
        "first": 0,
        "size": 1000,
        "isMetaRequired": false,
        "sort": [],
        "filter": [{ "field": "assuranceNumber", "operation": "=", "value": assuranceNumber }]
      });
      const data = response?.data || [];
      if (data.length > 0) {
        return data.filter(row => row.orgCtepId !== ctepId);
      }
      return data;
    } catch (err) {
      return rejectWithValue(err.response ? err.response.data : err.message);
    }
  }
);

const fwaSlice = createSlice({
  name: "Fwa",
  initialState,
  reducers: {
    saveSelectedFWARow: (state, action) => {
      state.selectedRow = action.payload;
    },
    saveFwaBrowserFilters: (state, action) => {
      state.fwaBrowserFilters = action.payload;
    }
  },
  extraReducers: {
    [fetchAssociatedInstitution.fulfilled]: (state, action) => {
      state.associatedInstitutions = action.payload;
    }
  }
});
export const { saveSelectedFWARow, saveFwaBrowserFilters } = fwaSlice.actions;
export default fwaSlice.reducer;
